var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_364_3601",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 46,
    height: 46
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.578125,
    y: 0.791016,
    width: 44.7844,
    height: 44.7844,
    fill: "url(#pattern0_364_3601)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_364_3601)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -6.63672,
    y: -10.7646,
    width: 54.897,
    height: 53.4523,
    fill: "#B2D9FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_364_3601",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_364_3601",
    transform: "translate(-0.00416667) scale(0.00833333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_364_3601",
    width: 121,
    height: 120,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRange);
export default __webpack_public_path__ + "static/media/range.2a37cdf44525120ba91c9d8156664325.svg";
export { ForwardRef as ReactComponent };